export const FEATURE_FLAG_PREFIX = 'coordi_feature_';

export const STORAGE_KEYS = {
  DEV_EXTRACTION_CACHE: 'coordi_dev_extraction_cache',
  DEV_SKIP_EXTRACTION: 'coordi_dev_skip_extraction',
  AUTH_CACHE: 'coordi_auth_cache',
  FLOW_STATE: 'coordimate-flow-state',
  THEME: 'theme',
  REMEMBER_ME: 'rememberMe',
  LOW_TOKEN_WARNING_DISMISSED: 'coordi-low-token-warning-dismissed',
  RECENTLY_USED_VARIABLES: 'recently-used-variables',
  DYNAMIC_RECENTLY_USED_VARIABLES: 'coordi-recently-used-variables',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS] | `${typeof FEATURE_FLAG_PREFIX}${string}`;

function isStorageAvailable(): boolean {
  return typeof window !== 'undefined';
}

export function getStorageItem<T = string>(
  key: StorageKey,
  parser?: (raw: string) => T
): T | null {
  if (!isStorageAvailable()) return null;

  try {
    const raw = window.localStorage.getItem(key);
    if (raw == null) return null;
    return parser ? parser(raw) : (raw as T);
  } catch {
    return null;
  }
}

export function setStorageItem<T>(
  key: StorageKey,
  value: T,
  serializer?: (value: T) => string
): void {
  if (!isStorageAvailable()) return;

  try {
    const serialized = serializer
      ? serializer(value)
      : typeof value === 'string'
      ? value
      : JSON.stringify(value);
    window.localStorage.setItem(key, serialized);
  } catch {
    // ignore storage write errors
  }
}

export function removeStorageItem(key: StorageKey): void {
  if (!isStorageAvailable()) return;

  try {
    window.localStorage.removeItem(key);
  } catch {
    // ignore storage delete errors
  }
}

export function getFeatureFlagStorageKey(flag: string): `${typeof FEATURE_FLAG_PREFIX}${string}` {
  return `${FEATURE_FLAG_PREFIX}${flag}`;
}
